import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex justify-end gap-6 lg:mb-6 lg:justify-between',
    link: 'heading-xs lg:heading-s flex items-center gap-2 hover:underline hover:underline-offset-4'
  }
});
